/// <reference path="../typings/index.d.ts" />
namespace App.Modulos {
  export class UsuarioDetalhes {
    public static inicializar() {
      var usuarioDetalhes = new App.UsuarioDetalhes();
      usuarioDetalhes.inicializarEventos();
    }
  }
}

namespace App {
  interface IPlano {
    id: number;
    nomePlano: string;
    dados: {
      valor_padrao: TipoPreco;
      fidelidade: TipoPreco;
      promocao_final_temporada: TipoPreco;
      promocao_blackfriday: TipoPreco;
    };
  }

  interface TipoPreco {
    status: boolean;
    multiplicar: boolean;
    valores: {
      brasil: { [key: string]: string };
      estrangeiro: { [key: string]: string };
    };
  }

  export class UsuarioDetalhes {

    private ajax: IAjax;
    private elBtnExcluir: JQuery = $(".btn-excluir");
    private elBtnRevincular: JQuery = $(".btn-revincular");
    private elBtnAtivarDesativar: JQuery = $(".btn-ativar-inativar");
    private elLinkVerMais: JQuery = $("#ver-mais");
    private elLinkVerMenos: JQuery = $("#ver-menos");
    private elCampoQtdContas: JQuery = $(".quantidadeContas");
    private elCampoTipoPrecoPlano: JQuery = $("#tipoPlanoPrecoVigente");
    private elCampoSelectPlano: JQuery = $('select[name=id_plano]');
    private elButtonLoginPorId: JQuery = $("#loginPorId");

    private elIdPlanoSelect: JQuery = $("#idPlanoSelect");
    private elQtdContasPlanoSelecionado: JQuery = $("#qtdContasParaUpgrade");
    private elTipoPlanoDescontos: JQuery = $("#tipoPlanoDesconto");
    private elUpgradePlano: JQuery = $("#divUpgradePlano");
    private elMainAdmin: JQuery = $("#mainAdmin");
    private planos: IPlano[] = null;

    private util: any = null;

    private dados: { valorPadrao: string; valorPlanoSelecionado: string; desconto: string; aPagarPadrao: string; aPagarSelecionado: string } =
      { valorPadrao: '',valorPlanoSelecionado: '',desconto: '',aPagarPadrao: '',aPagarSelecionado: '' };

    private calculoUpgrade: {
      saldoRestanteFormatado: string;
      quantidadeAtualDeContas: any;
      saldoRestante: number; valorPlanoAtualFormatado: string,valorPlanoUpgrade: number,valorPlanoUpgradeFormatado: string,diasRestantes: number,totalDiasMes: number,valorUpgrade:
      number,valorUpgradeFormatado: string,valorPorConta: any,valorPorContaFormatado: string,descricaoPlanoDesejado: string;
    } = {
        valorPlanoAtualFormatado: '',diasRestantes: 0,totalDiasMes: 30,valorUpgrade: 0,valorUpgradeFormatado: '',saldoRestante: 0,quantidadeAtualDeContas: 0,valorPlanoUpgrade: 0,
        valorPlanoUpgradeFormatado: '',saldoRestanteFormatado: '',valorPorConta: 0,valorPorContaFormatado: '',descricaoPlanoDesejado: ''
      };

    public inicializarEventos() {
      this.elBtnExcluir.on("click",(e) => { this.aoExcluirRegistro(e) });
      this.elBtnRevincular.on("click",(e) => { this.aoRevincular(e) });
      this.elBtnAtivarDesativar.on("click",(e) => { this.aoAtivarDesativarContaEa(e) });
      this.elLinkVerMais.on("click",(e) => { this.verMais() });
      this.elLinkVerMenos.on("click",(e) => { this.verMenos() });
      this.elButtonLoginPorId.on("click",(e) => { this.logarPorId(e) });

      this.elCampoQtdContas.on('keyup',(e) => { this.calcularCampoValor(e) });
      this.elCampoTipoPrecoPlano.on('change',(e) => { this.calcularCampoValor(e) });
      this.elCampoSelectPlano.on('change',(e) => { this.calcularCampoValor(e) });

      this.elIdPlanoSelect.on('change',(e) => { this.iniciarCalculoUpgrade(e) });
      this.elTipoPlanoDescontos.on('change',(e) => { this.iniciarCalculoUpgrade(e) });
      this.elQtdContasPlanoSelecionado.on('keyup',this.debounce((e: JQueryEventObject) => { this.iniciarCalculoUpgrade(e); },800));

      this.inicializarCrudServidor()
      this.util = new Util()
      this.planos = this.elMainAdmin.data("planos");
      console.log("planos",this.planos);
    }

    private debounce(func: Function,wait: number) {
      let timeout: number | undefined;
      return (...args: any[]) => {
        clearTimeout(timeout);
        timeout = window.setTimeout(() => func.apply(this,args),wait);
      };
    }

    private async calcularCampoValor(e: JQueryEventObject) {
      let qtdContas = this.elCampoQtdContas.val();
      let tipoPrecoPlano = this.elCampoTipoPrecoPlano.val();
      let idPlano = parseInt(this.elCampoSelectPlano.val());
      let precoPlanoCalculado: any = await this.util.getPrecoPlano(idPlano,qtdContas,tipoPrecoPlano,this.planos);

      if (!precoPlanoCalculado) {
        $(".valor").val(0)
        return
      }

      $(".valor").val(parseFloat(precoPlanoCalculado).toFixed(2));
    }

    private verMais() {
      $('.mais-calculos-planos').show();
      $('#ver-mais').hide();
      $('#ver-menos').show();
      return;
    }

    private verMenos() {
      $('.mais-calculos-planos').hide();
      $('#ver-mais').show();
      $('#ver-menos').hide();
      return;
    }

    private aoExcluirRegistro(e: JQueryEventObject) {
      App.Util.exebirSweetConfirmacao(e,"Você tem certeza disso?","Essa ação não pode ser revertida","Sim, continuar",this.excluirRegistro);
      return;
    }

    private aoAtivarDesativarContaEa(e: JQueryEventObject) {
      this.ajax = new App.Ajax();
      this.ajax.postAcaoSemCabecalhoGlobal($(e.currentTarget).data("url"),{ id: $(e.currentTarget).data("id") });
    }

    private excluirRegistro(e: JQueryEventObject) {
      this.ajax = new App.Ajax();
      this.ajax.postAcaoSemCabecalhoGlobal($(e.currentTarget).data("url"),{ id: $(e.currentTarget).data("id") },App.UsuarioDetalhes.excluirRegistroNaPagina,e);
    }

    public static excluirRegistroNaPagina(dados: IRespostaSucessoAjx) {
      let e: JQueryEventObject = dados.parametroCallback;
      $(e.currentTarget).parents("li").remove();
    }

    private aoRevincular(e: JQueryEventObject) {
      swal({
        title: 'Informe o ID da conta FUTSNIPERWEB que receberá a conta EA ' + $(e.currentTarget).data("nome"),
        customClass: 'popup-input',
        input: 'number',
        inputAttributes: {
          autocapitalize: 'off'
        },
        showCancelButton: true,
        confirmButtonText: 'Vincular agora',
        showLoaderOnConfirm: true,
        preConfirm: (idUserNovaConta: number) => {
          this.ajax = new App.Ajax();
          this.ajax.postAcaoSemCabecalhoGlobal($(e.currentTarget).data("url"),{ id: $(e.currentTarget).data("id"),idUserNovaConta: idUserNovaConta },App.UsuarioDetalhes.excluirRegistroNaPagina,e);
        },
        allowOutsideClick: () => !swal.isLoading()
      })
    }

    private inicializarCrudServidor() {
      var modelViewServidor = new ModelView();
      modelViewServidor.elBtnEditar = $(".btn-editar-servidor");
      modelViewServidor.elBtnExcluir = $(".btn-excluir-servidor");

      modelViewServidor.inicializar($('.form-step-config-servidor'),true,(dados: IRespostaSucessoAjx) => {
        let e: JQueryEventObject = dados.parametroCallback;
        $(e.currentTarget).parents('tr').remove();
      });

      modelViewServidor.aoEditarRegistro = (e: JQueryEventObject,_this: this) => {
        let idRegistro = $(e.currentTarget).data("id")
        var modal = $(`#modalCadastrarServidor${idRegistro}`);
        modal.modal('show');
      };

      modelViewServidor.ojDataTableCarregado.elDataTable = $("#dataTableServidores");
      modelViewServidor.carregardataTable()
    }

    private logarPorId(e: JQueryEventObject) {
      this.ajax = new App.Ajax();
      this.ajax.postAcao($(e.currentTarget).data("url"),{ id: $(e.currentTarget).data("id") },(resp: { status: boolean,redirect: string }) => {
        if (resp.status) {
          toastr.success("Conta logada","Sucessso!");
          setTimeout(() => {
            window.location.href = "/";
          },2000)
        } else {
          toastr.warning("Um erro ocorreu ao logar a conta.","Error!");
        }
      });
    }

    private async iniciarCalculoUpgrade(e: JQueryEventObject): Promise<void> {
      this.limparViewUpgrade();

      try {
        const idPlano = Number(this.elIdPlanoSelect.val());
        const qtdContasSelecionada = Number(this.elQtdContasPlanoSelecionado.val());
        const tipoPlanoDescontos = String(this.elTipoPlanoDescontos.val());
        const seletorEstrangeiro = String(this.elUpgradePlano.data("estrangeiro"));
        const estrangeiro = seletorEstrangeiro !== 'BRL';
        const saldo = Number(this.elUpgradePlano.data("saldo") || 0);

        // Validação de segurança — evita erros silenciosos
        if (!idPlano || !qtdContasSelecionada || idPlano === 1 ) {
          toastr.warning("Selecione um plano e quantidade de contas válidos.","Atenção!");
          return;
        }
        const valorPadrao = await this.util.getPrecoPlano(idPlano,qtdContasSelecionada,'valor_padrao',this.planos,estrangeiro);
        const valorPlanoSelecionado = await this.util.getPrecoPlano(idPlano,qtdContasSelecionada,tipoPlanoDescontos,this.planos,estrangeiro);
        const desconto = valorPadrao - valorPlanoSelecionado;
        const aPagarPadrao = valorPadrao - saldo;
        const aPagarSelecionado = valorPlanoSelecionado - saldo;

        this.dados.valorPadrao = this.formatarMoedaBR(valorPadrao);
        this.dados.valorPlanoSelecionado = this.formatarMoedaBR(valorPlanoSelecionado);
        this.dados.desconto = String(this.formatarMoedaBR(desconto));
        this.dados.aPagarPadrao = String(this.formatarMoedaBR(aPagarPadrao));
        this.dados.aPagarSelecionado = String(this.formatarMoedaBR(aPagarSelecionado));

        const valorPlanoUpgrade = await this.util.getPrecoPlano(idPlano,qtdContasSelecionada,tipoPlanoDescontos,this.planos,estrangeiro,
          (valorPorConta: any) => this.definirValorPorConta(valorPorConta,estrangeiro,seletorEstrangeiro));

        // Armazena dados do cálculo
        Object.assign(this.calculoUpgrade,{
          valorPlanoUpgrade,saldoRestante: saldo,valorPlanoUpgradeFormatado: estrangeiro ? `${seletorEstrangeiro} ${valorPlanoUpgrade.toFixed(2)}` : `R$ ${this.formatarNumero(valorPlanoUpgrade)}`,
          descricaoPlanoDesejado: `Plano ${qtdContasSelecionada} contas`
        });

        await this.calcularUpgrade();
        this.preencherViewUpgrade();

      } catch (error) {
        console.error("Erro ao calcular upgrade:",error);
        toastr.warning(error.message || "Erro desconhecido ao realizar upgrade.","Erro Upgrade!");
      }
    }

    /**
     * Calcula os valores finais do upgrade e formata para exibição.
     */
    private async calcularUpgrade(): Promise<void> {
      const { saldoRestante = 0,valorPlanoUpgrade = 0 } = this.calculoUpgrade;

      const valorUpgrade = valorPlanoUpgrade - saldoRestante;

      Object.assign(this.calculoUpgrade,{
        saldoRestanteFormatado: this.formatarNumero(saldoRestante),
        valorUpgrade,valorUpgradeFormatado: this.formatarNumero(valorUpgrade)
      });
    }

    /**
     * Define o valor por conta formatado, usado no cálculo do upgrade.
     */
    private definirValorPorConta(valorPorConta: any,estrangeiro: boolean,moeda: string): void {
      const valorNumerico = Number(valorPorConta);
      const valorFormatado = estrangeiro ? `${moeda} ${valorNumerico.toFixed(2)}` : `R$ ${this.formatarNumero(valorNumerico)}`;

      Object.assign(this.calculoUpgrade,{
        valorPorConta: valorNumerico,valorPorContaFormatado: valorFormatado
      });
    }

    /**
     * Atualiza a view com os valores calculados.
     */
    private preencherViewUpgrade(): void {
      const {
        valorPlanoUpgradeFormatado = '',
        valorUpgradeFormatado = '',
        saldoRestanteFormatado = '',
        descricaoPlanoDesejado = '',
        valorPorContaFormatado = ''
      } = this.calculoUpgrade;

      const { valorPadrao = '',valorPlanoSelecionado = '',desconto = '',aPagarPadrao = '',aPagarSelecionado = '' } = this.dados;
      const textoSelecionado = this.elTipoPlanoDescontos.find("option:selected").text().trim();

      $("#valorPlanoUpgrade").text(valorPlanoUpgradeFormatado);
      $("#valorUpgrade").text(valorUpgradeFormatado);
      $("#saldoRestanteCalc").text(saldoRestanteFormatado);
      $("#valorPorConta").text(valorPorContaFormatado);
      $("#descricaoPlanoDesejado").text(descricaoPlanoDesejado);

      $("#valorPadrao").text(valorPadrao);
      $("#valorPlanoSelecionado").text(valorPlanoSelecionado);
      $("#desconto").text(desconto);
      $("#aPagarPadrao").text(aPagarPadrao);
      $("#aPagarSelecionado").text(aPagarSelecionado);

      $("#descricaoPlanoSelecionado").text(`valor ${textoSelecionado}`);
    }

    /**
     * Limpa os campos de exibição do cálculo de upgrade.
     */
    private limparViewUpgrade(): void {
      ["#valorPlanoUpgrade","#valorUpgrade","#saldoRestanteCalc","#valorPorConta"].forEach(selector => {
        $(selector).text("");
      });
    }

    private formatarNumero(valor: number): string {
      return valor.toFixed(2).replace(".",",");
    }

    private formatarMoedaBR(valor: number): string {
      if (isNaN(valor)) return 'R$ 0,00';

      return new Intl.NumberFormat('pt-BR',{
        style: 'currency',
        currency: 'BRL',
        minimumFractionDigits: 2,
      }).format(valor);
    }

  }
}
